<div class="rounded-panel-wrap"
     [class.bg-primary]="fillBackground">
  <div class="rounded-panel"></div>
</div>
